/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../Table/Table";
import { view_icon } from "../../assets/img";
import moment from "moment";
import { checkPermission } from "../../screen/redux/api/PermissionManager";

const MMCApproveList = ({ list, setPage, pagination, page }) => {
  const navigate = useNavigate();
  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "Property",
        accessor: "property_name",
        Cell: ({ value, row }) => {
          return (
            <div
              onClick={() => {
                navigate("/property-details", {
                  state: {
                    id: row.original?.property_id,
                    owner: row.original?.owner_id,
                    category_id: row.original?.category_id,
                  },
                });
              }}
              className="text-nowrap"
            >
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.property_code}</p>
            </div>
          );
        },
      },
      {
        Header: "Platform",
        accessor: "payment_device",
        Cell: ({ value, row }) => {
          return (
            <div onClick={() => {}} className="text-nowrap">
              {/* <p className="primary pointer">{value}</p> */}
              <p
                style={{
                  color:
                    row.original.payment_device === "IOS"
                      ? "#ae55f5"
                      : "#3a3a49",
                }}
              >
                {row.original?.payment_device}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Approved By",
        accessor: "approved_by",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Approved Date",
        accessor: "approved_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD-MM-YYYY")}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <button className="active-btn p-1 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
              Approved
            </button>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              {/* {givenpermissions?.includes("CAN-Edit-ADMINS") && ( */}
              <button
                onClick={() => {
                  navigate("/mmc-cancel-appr-view", {
                    state: { type: "view", property: row.original },
                  });
                  // AdminView(row.original.id, "edit");
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className=" edit-btn " />
              </button>
              {/* )} */}
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-MMC_CANCELLATION") ? [...d, action] : d;
  }, [page]);

  return (
    <Table
      columns={columns}
      setPageno={setPage}
      pagecount={pagination}
      data={list}
      show={true}
    />
  );
};
export default MMCApproveList;
